import { render, staticRenderFns } from "./textLibrarySelectModal.vue?vue&type=template&id=185b3863&scoped=true"
import script from "./textLibrarySelectModal.vue?vue&type=script&lang=js"
export * from "./textLibrarySelectModal.vue?vue&type=script&lang=js"
import style0 from "./textLibrarySelectModal.vue?vue&type=style&index=0&id=185b3863&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185b3863",
  null
  
)

export default component.exports